import { mockData } from "./Mock";
import { Resume, EducationLevel, Gender, SchoolType, CompanyType } from "../../models/Resume";

const mockRemoteWorkPhotoUrl = "https://pub-img-wfile.yuanling.com/3/33/45/6/49/5eafce2266281a71a0f693d1483cf67851d1181f2de225f97a00a212.png";
// 简历列表mock数据
mockData.set("getResumes", [
    {
        id: "RES001",
        name: "张三",
        birthDate: "1990-05-15",
        householdCity: "北京市",
        wechatId: "zhangsan123",
        email: "zhangsan@example.com",
        phone: "13800138001",
        firstWorkDate: "2012-07",
        expectedSalaryStart: 15,
        expectedSalaryEnd: 25,
        remoteWorkPhotoUrl: mockRemoteWorkPhotoUrl,
        personalAdvantage: "5年Java开发经验，熟悉Spring Boot、MySQL等技术栈",
        education: EducationLevel.MASTER,
        gender: Gender.MALE,
        educationHistory: [
            {
                schoolName: "清华大学",
                major: "计算机科学与技术",
                startDate: "2008-09",
                endDate: "2012-07",
                awards: "优秀毕业生",
                schoolLevel: [SchoolType.TOP_4]
            }
        ],
        workHistory: [
            {
                companyName: "阿里巴巴",
                position: "高级Java开发工程师",
                workContent: "负责电商平台核心业务开发",
                workAwards: "年度优秀员工",
                startDate: "2018-03",
                endDate: "2023-06",
                skills: "Java, Spring Boot, MySQL, Redis"
            }
        ],
        papers: [],
        certificates: [],
        bestSchoolType: SchoolType.TOP_4,
        bestCompanyType: CompanyType.BBAT,
        servedMonthCount: 18,
        isServing: true,
        createdAt: "2023-01-15T10:00:00Z",
        updatedAt: "2024-01-15T10:00:00Z"
    }
]);

// 简历详情mock数据
mockData.set("getResumeDetail", {
    id: "RES001",
    name: "张三",
    birthDate: "1990-05-15",
    householdCity: "北京市",
    wechatId: "zhangsan123",
    email: "zhangsan@example.com",
    phone: "13800138001",
    firstWorkDate: "2012-07",
    expectedSalaryStart: 15,
    expectedSalaryEnd: 25,
    remoteWorkPhotoUrl: mockRemoteWorkPhotoUrl,
    personalAdvantage: "5年Java开发经验，熟悉Spring Boot、MySQL等技术栈",
    education: EducationLevel.MASTER,
    gender: Gender.MALE,
    educationHistory: [
        {
            schoolName: "清华大学",
            major: "计算机科学与技术",
            startDate: "2008-09",
            endDate: "2012-07",
            awards: "优秀毕业生",
            schoolLevel: [SchoolType.TOP_4]
        }
    ],
    workHistory: [
        {
            companyName: "阿里巴巴",
            position: "高级Java开发工程师",
            workContent: "负责电商平台核心业务开发",
            workAwards: "年度优秀员工",
            startDate: "2018-03",
            endDate: "2023-06",
            skills: "Java, Spring Boot, MySQL, Redis"
        }
    ],
    papers: [],
    certificates: [],
    bestSchoolType: SchoolType.TOP_4,
    bestCompanyType: CompanyType.BBAT,
    servedMonthCount: 18,
    isServing: true,
    createdAt: "2023-01-15T10:00:00Z",
    updatedAt: "2024-01-15T10:00:00Z"
}); 